/* eslint-disable react/jsx-key */
import React, { useState } from 'react'
import { strCol } from '@integec/grid-tools/lib/cols'
import { getApiTargetInfo } from 'core'
import { modifierCol, modifiedDateCol } from 'core/HeaderColTypeProps'
import { connect } from 'react-redux'
import {
  getAmpCodeMgmtInfo,
  postAmpCodeMgmtInfo,
  deleteAmpCodeMgmtInfo,
} from 'api/pgads.js'
import { Input, Button } from 'antd'
import { STORE_AMPLIFICATION } from 'core/action-names'
import CommonScreen from './CommonScreen'

const headers = [
  strCol({
    ident: 'ampCode',
    display: 'Amplification Code',
    isKey: true,
    width: 150,
  }),
  strCol({
    ident: 'description',
    display: 'Description',
    width: 700,
    isRequired: true,
    alignment: 'left',
    ellipsis: true,
  }),
  modifierCol,
  modifiedDateCol,
]

const retrieveTask = apiTargetInfo => getAmpCodeMgmtInfo(apiTargetInfo)

const modifyTask = apiTargetInfo => data =>
  postAmpCodeMgmtInfo(apiTargetInfo)(data)

const deleteTask = apiTargetInfo => data =>
  deleteAmpCodeMgmtInfo(apiTargetInfo)(data)

const title = 'Amplification Code Management'

const AmpCodeMgmt = props => {
  const [insertEvent, setInsertEvent] = useState(false)

  // const setData = data => {
  //   setInsertData({ ...insertData, ...data })
  // }
  // const onCancel = () => {
  //   setInsertEvent(false)
  // }

  // const onAdd = ({ hide, retrieve }) => {
  //   if (insertData.ampCode === undefined || insertData.ampCode.trim().length == 0) {
  //     message.error('Please, Insert Amplification Code before Save')
  //     return
  //   }

  //   modifyTask(apiTargetInfo)([insertData]).fork(setErr, _ => {
  //     message.info('Data Saved')
  //     setInsertEvent(!hide)
  //     setInsertData({})
  //     retrieve && retrieve()
  //   })
  // }
  // useEffect(() => {
  //   setInsertData({})
  // }, [insertEvent])

  const insertComp = ({ insertData, setInsertData, onAdd, onCancel }) => {
    return (
      <div
        style={{
          display: 'grid',
          gridTemplateColumns: '150px 100px 100px 400px auto auto auto',
          gridColumnGap: '20px',
        }}
      >
        <div style={{ display: 'grid', alignContent: 'center' }}>
          Amplification Code :{' '}
        </div>

        <Input
          placeholder="Amp Code"
          value={insertData.ampCode}
          onChange={e =>
            setInsertData({ ...insertData, ampCode: e.target.value })
          }
          maxLength={2}
        />

        <div style={{ display: 'grid', alignContent: 'center' }}>
          Description :{' '}
        </div>

        <Input
          placeholder="Description"
          value={insertData.description}
          onChange={e =>
            setInsertData({ ...insertData, description: e.target.value })
          }
        />

        <Button type="primary" onClick={() => onAdd(true)}>
          Add
        </Button>

        <Button type="primary" onClick={() => onAdd(false)}>
          Add & Hide
        </Button>
        <Button type="danger" onClick={onCancel}>
          Cancel
        </Button>
      </div>
    )
  }

  const onRetrieveData = data => {
    props.saveAmpCode(data)
  }

  return [
    <CommonScreen
      title={title}
      header={headers}
      saveTask={modifyTask}
      retrieveTask={retrieveTask}
      deleteTask={deleteTask}
      altBy={d => d.stationName}
      autoRetrieve
      sortOptions={[
        { ident: 'ampCode', display: 'Amplification Code', sortOrder: 'asc' },
      ]}
      insertComp={insertEvent && insertComp}
      insertCompHeight={150}
      onInsertEvent={b => setInsertEvent(b)}
      // widthOffset={150}
      totalWidth={1200}
      onRetrieveData={onRetrieveData}
    />,
  ]
}

const mapStateToProps = state => ({
  apiTargetInfo: getApiTargetInfo(state),
})

const mapDispathcToProps = dispatch => ({
  saveAmpCode: ampCode =>
    dispatch({ type: STORE_AMPLIFICATION, payload: ampCode }),
})

export default connect(mapStateToProps, mapDispathcToProps)(AmpCodeMgmt)
